import { INVENTORY_MODULE } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import axios, { AxiosError } from "axios";
import { useCallback } from "react";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";

AxiosCurlirize(axios, () => {});

export interface IFinanceConfigChangeActionPayload {
  request_id: string;
  action: "approved" | "rejected";
  reason?: string | null;
  status?: string | null;
  start_date?: string | null;
  end_date?: string | null;
  page_size?: number | null;
  page_number?: number | null;
}

interface IFinanceConfigChangeActionResponse {
  status: boolean;
  message?: string;
}

export const useFinanceConfigChangeActionAPI = () => {
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (payload: IFinanceConfigChangeActionPayload) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response = await axios.put<IFinanceConfigChangeActionResponse>(
          INVENTORY_MODULE?.FINANCE_CONFIG_CHANGE_ACTION?.baseURL ?? "",
          {
            request_id: payload.request_id,
            action: payload.action,
            reason: payload.reason ?? "",
            status: payload.status ?? null,
            start_date: payload.start_date ?? null,
            end_date: payload.end_date ?? null,
            page_size: payload.page_size ?? null,
            page_number: payload.page_number ?? null,
          },
          {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          },
        );

        return {
          status: response.data?.status === true,
          message: response.data?.message ?? "",
        };
      } catch (e: unknown) {
        const error = e as AxiosError;
        sendCurl(error?.config?.["curlCommand"]);
        captureError(error);
        return {
          status: false,
          message: error?.message ?? "Failed to update request",
        };
      }
    },
    [captureError, configuration.localStorage.ACCESS_TOKEN.key, sendCurl],
  );

  return { execute };
};
